/**
 * 生成疊影 (Ghost Overlay) 圖片
 * 參考 ghost_overlay_spec.md 的 Sobel Filter 實作
 */

export async function processGhostImage(dataUrl) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      // 為了效能與對位準確度，限制最大尺寸
      const MAX_WIDTH = 1280;
      let width = img.width;
      let height = img.height;

      if (width > MAX_WIDTH) {
        height = (MAX_WIDTH / width) * height;
        width = MAX_WIDTH;
      }

      canvas.width = width;
      canvas.height = height;
      ctx.drawImage(img, 0, 0, width, height);

      const imageData = ctx.getImageData(0, 0, width, height);
      const data = imageData.data;
      const width_int = imageData.width;
      const height_int = imageData.height;

      // 1. 灰階化
      const grayscale = new Uint8ClampedArray(width_int * height_int);
      for (let i = 0; i < data.length; i += 4) {
        const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
        grayscale[i / 4] = avg;
      }

      // 2. Sobel 算子
      const sobelX = [
        -1, 0, 1,
        -2, 0, 2,
        -1, 0, 1
      ];
      const sobelY = [
        -1, -2, -1,
         0,  0,  0,
         1,  2,  1
      ];

      const outputData = ctx.createImageData(width_int, height_int);
      const output = outputData.data;

      for (let y = 1; y < height_int - 1; y++) {
        for (let x = 1; x < width_int - 1; x++) {
          let pixelX = 0;
          let pixelY = 0;

          for (let ky = -1; ky <= 1; ky++) {
            for (let kx = -1; kx <= 1; kx++) {
              const pixel = grayscale[(y + ky) * width_int + (x + kx)];
              pixelX += pixel * sobelX[(ky + 1) * 3 + (kx + 1)];
              pixelY += pixel * sobelY[(ky + 1) * 3 + (kx + 1)];
            }
          }

          const magnitude = Math.sqrt(pixelX * pixelX + pixelY * pixelY);
          const idx = (y * width_int + x) * 4;

          // 3. 像素處理：將輪廓轉為綠色，其餘設為透明
          // 靈敏度調整：參考規格 amount 0.8，這裡用 > 40 作為閾值
          if (magnitude < 40) {
            output[idx + 3] = 0; // 完全透明
          } else {
            output[idx] = 0;     // R
            output[idx + 1] = 255; // G (強化綠色)
            output[idx + 2] = 0;   // B
            // 透明度隨強度變化，最大 200 (避免太刺眼)
            output[idx + 3] = Math.min(200, magnitude * 2); 
          }
        }
      }

      ctx.putImageData(outputData, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = dataUrl;
  });
}
